import { render, staticRenderFns } from "./BtnMostrarJustificativa.vue?vue&type=template&id=941047a0"
import script from "./BtnMostrarJustificativa.vue?vue&type=script&lang=js"
export * from "./BtnMostrarJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports